import { render } from "./ShowCatalog.vue?vue&type=template&id=b639d722"
import script from "./ShowCatalog.vue?vue&type=script&lang=js"
export * from "./ShowCatalog.vue?vue&type=script&lang=js"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__